<template>
  <div>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialogState" width="560" height="auto">
          <v-card style="background:#35362F">
            <v-card-title class="text-center white--text">
              Cement
            </v-card-title>
            <v-card-text class="white--text text-body-1">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia
              quasi officia exercitationem, sunt quis reiciendis. Quis minus,
              quam voluptate optio nam velit! Tempore, repellat. Aut itaque
              praesentium tenetur aliquid unde.
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogState: false
    }
  },
  watch: {
    dialog(val) {
      this.dialogState = val
    },
    dialogState(val) {
      this.$emit('update:dialog', val)
    }
  },
  methods: {
    turnOffDialog() {
      this.dialogState = false
      this.$emit('update:dialog', this.dialogState)
    }
  }
}
</script>

<style lang="css" scoped>
.anotation-box {
  order: 1px solid #fff;
  border-radius: 18px;
  font-size: 16px;
  font-family: sans-serif;
  line-height: 26px;
  color: #fff;
  text-align: center;
  user-select: none;
  background: rgba(0, 0, 0, 0.8);
}
</style>
